import React, { useState } from 'react';

import './styles.css';

import { SECTIONS, scrollTo } from '../../Anchor';

const MENU_ITEMS = [
  {
    title: 'Начало',
    section: SECTIONS.FUTEURE_COMMING,
  },
  {
    title: 'Развитие поколений связи',
    section: SECTIONS.HISTORY_PROGRESS,
  },
  {
    title: 'Карта развития',
    section: SECTIONS.HISTORY_MAP,
  },
  {
    title: 'Сферы применения',
    section: SECTIONS.TECHNOLOGIES,
  },
  {
    title: 'Спидометр',
    section: SECTIONS.SPEED,
  },
  {
    title: 'Интервью',
    section: SECTIONS.INTERVIEW,
  },
];

export default props => {
  return (
    <div className="Menu">
      {MENU_ITEMS.map((item, index) => (
        <div
          className="Menu__item"
          key={index}
          onClick={() => scrollTo(item.section, props.closeSidebar)}
        >
          {item.title}
        </div>
      ))}
    </div>
  );
};
